<template>
  <div class="flex flex-col min-h-screen w-full bg-white">
    <cabecera-gob-mx />
    
    <main class="flex-1">

      <section class="p-10 mx-auto max-w-5xl space-y-5">
        <h1 class="text-5xl font-bold pt-20">
          Apporta
        </h1>
        <img src="@/assets/logos-instituciones/icon-only.png" alt="" class="h-40">
        
        <p class="text-lg pt-10">
          Apporta es una plataforma desarrollada por CONAHCYT y CentroGeo 
          diseñada para facilitar el levantamiento de datos georeferenciados 
          con el propósito de abordar problemas prioritarios de manera eficiente.
        </p>
        <p class="text-lg">
          Con una interfaz intuitiva, permite a los usuarios recopilar 
          información precisa en tiempo real facilitando la toma de 
          decisiones informadas.
        </p>
        <p class="text-lg">
          Al ser una aplicación de libre acceso, promueve la colaboración y 
          participación ciudadana, fomentando así la generación de 
          soluciones efectivas para los desafíos más apremiantes de nuestra sociedad.
        </p>

        <p class="flex gap-5 py-10">
          <img 
            src="@/assets/logos-instituciones/gobierno-mexico.webp" 
            alt="Gobierno de México"
            class="h-10"
          >
          <img
            src="@/assets/logos-instituciones/secretaria-bienestar.webp"
            alt="Secretaría del Bienestar"
            class="h-10"
          >
          <img 
            src="@/assets/logos-instituciones/programa-sembrando-vida.webp"
            alt="Sembrando Vida"
            class="h-10"
          >
        </p>

      </section>

      <section class="">
        <div class="p-10 mx-auto max-w-5xl flex gap-5">
          <div>
            <p>
              <a href="/registro" class="hover:underline">Regístrate</a>
            </p>
          </div>
          <div>
            <p>
              <a href="/login" class="hover:underline">Iniciar sesión</a>
            </p>
          </div>
        </div>
      </section>

      <section class="bg-gray-100 py-10">
        <div class="p-10 mx-auto max-w-5xl space-y-5">
          <h2 class="text-3xl font-bold">Características Principales</h2>
          <p>
            La aplicación permite hacer levantamientos de información con base en encuestas o 
            cuestionarios de proyectos relativos a comunidad, eventos, o cualquier tema definido por los administradores.
          </p>
          <p>
            Las versiones públicas se encuentran disponible para dispositivos móviles en 
            <a href="https://play.google.com/store/apps/details?id=com.centrogeo.apporta&hl=es_MX">Google Play</a>
            y en la 
            <a href="https://apps.apple.com/mx/app/apporta/id6472007951">App Store</a>.
          </p>

          <h3 class="text-xl font-bold pt-5">Datos que podría recopilar Apporta</h3>
          <div class="flex gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f"><path d="M234-276q51-39 114-61.5T480-360q69 0 132 22.5T726-276q35-41 54.5-93T800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 59 19.5 111t54.5 93Zm146.5-204.5Q340-521 340-580t40.5-99.5Q421-720 480-720t99.5 40.5Q620-639 620-580t-40.5 99.5Q539-440 480-440t-99.5-40.5ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm100-95.5q47-15.5 86-44.5-39-29-86-44.5T480-280q-53 0-100 15.5T294-220q39 29 86 44.5T480-160q53 0 100-15.5ZM523-537q17-17 17-43t-17-43q-17-17-43-17t-43 17q-17 17-17 43t17 43q17 17 43 17t43-17Zm-43-43Zm0 360Z"/></svg>
            <p>
              <b>Información personal</b><br/>
              Nombre, Dirección de correo electrónico y Otra información
            </p>
          </div>
          <div class="flex gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f"><path d="M360-400h400L622-580l-92 120-62-80-108 140Zm-40 160q-33 0-56.5-23.5T240-320v-480q0-33 23.5-56.5T320-880h480q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H320Zm0-80h480v-480H320v480ZM160-80q-33 0-56.5-23.5T80-160v-560h80v560h560v80H160Zm160-720v480-480Z"/></svg>
            <p>
              <b>Fotos y videos</b><br/>
              Fotos
            </p>
          </div>
          <div class="flex gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f"><path d="M536.5-503.5Q560-527 560-560t-23.5-56.5Q513-640 480-640t-56.5 23.5Q400-593 400-560t23.5 56.5Q447-480 480-480t56.5-23.5ZM480-186q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z"/></svg>
            <p>
              <b>Ubicación</b><br/>
              Ubicación precisa
            </p>
          </div>
        </div>
      </section>

    </main>
    
    <piedepagina-gob-mx />
  </div>
</template>

<style scoped>
</style>

<script>
import CabeceraGobMx from "./CabeceraGobMx.vue";
import PiedepaginaGobMx from "./PiedepaginaGobMx.vue";

export default {
  data() {
    return {};
  },
  components: {
    CabeceraGobMx,
    PiedepaginaGobMx,
  },
  computed: {},
  methods: {},
};
</script>
